import axios from "axios";
import MainService from "./MainService";

export default class ReceivementService extends MainService {
  constructor() {
		super();
		this.url = `${this.apiUrl}/receivements`;
  }

  save(receivement) {
    return axios.post(this.url, receivement);
  }

  delete(id) {
    return axios.delete(this.url + "/" + id);
  }
}



// WEBPACK FOOTER //
// ./src/service/ReceivementService.js